module.exports = __webpack_public_path__ + "img/179940.fb9e972d.png";